import { backupLang } from "../../../data/admin";
import { langsCodes } from "../../../data/main";

export const updateBackupLang = (lang: string, code: string, text: string) => {
  const langText = langsCodes[lang];
  if (!(langText in backupLang) || !(code in backupLang[langText])) {
    if (!(langText in backupLang)) {
      backupLang[langText] = {};
    }
    backupLang[langText][code] = text;
  }
};
